import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
GET_ACTION_TEMPLATES,
SG_GET_ACTION_TEMPLATES,
FETCH_ACTION_TEMPLATE,
SG_FETCH_ACTION_TEMPLATE,
ADD_ACTION_TEMPLATE,
SG_ADD_ACTION_TEMPLATE,
EDIT_ACTION_TEMPLATE,
SG_EDIT_ACTION_TEMPLATE,
DELETE_ACTION_TEMPLATE,
SG_DELETE_ACTION_TEMPLATE,
	TEMPLATES_STATISTICS,
	SG_TEMPLATES_STATISTICS,
	TEMPLATES_BULK_ACTIONS,
	SG_TEMPLATES_BULK_ACTIONS,
	TEMPLATES_AVAILABLE_POSTMARK,
	SG_TEMPLATES_AVAILABLE_POSTMARK,
	TEMPLATES_AUTO_ASSIGN,
	SG_TEMPLATES_AUTO_ASSIGN,
	TEMPLATE_VERIFY,
	SG_TEMPLATE_VERIFY,
} from "constants/actions";

/* Templates */

function* loadTemplates(action) {
	try {
		const json = yield call(api.GET_ACTION_TEMPLATES, action.payload);
		yield put({ type: GET_ACTION_TEMPLATES, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templatesLoad() {
	yield takeLatest(SG_GET_ACTION_TEMPLATES, loadTemplates);
}

function* fetchTemplate(action) {
	try {
		const json = yield call(api.FETCH_ACTION_TEMPLATE, action.payload);
		yield put({ type: FETCH_ACTION_TEMPLATE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templateFetch() {
	yield takeLatest(SG_FETCH_ACTION_TEMPLATE, fetchTemplate);
}

function* addTemplate(action) {
	try {
		const json = yield call(api.ADD_ACTION_TEMPLATE, action.payload);
		yield put({ type: ADD_ACTION_TEMPLATE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templateAdd() {
	yield takeLatest(SG_ADD_ACTION_TEMPLATE, addTemplate);
}

function* editTemplate(action) {
	try {
		const json = yield call(api.EDIT_ACTION_TEMPLATE, action.payload);
		yield put({ type: EDIT_ACTION_TEMPLATE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templateEdit() {
	yield takeLatest(SG_EDIT_ACTION_TEMPLATE, editTemplate);
}

function* deleteTemplate(action) {
	try {
		const json = yield call(api.DELETE_ACTION_TEMPLATE, action.payload);
		yield put({ type: DELETE_ACTION_TEMPLATE, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templateDelete() {
	yield takeLatest(SG_DELETE_ACTION_TEMPLATE, deleteTemplate);
}

function* templatesStatistics(action) {
	try {
		const json = yield call(api.TEMPLATES_STATISTICS, action.payload);
		yield put({ type: TEMPLATES_STATISTICS, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templatesStatisticsLoad() {
	yield takeLatest(SG_TEMPLATES_STATISTICS, templatesStatistics);
}

function* templatesBulkActions(action) {
	try {
		const json = yield call(api.TEMPLATES_BULK_ACTIONS, action.payload);
		yield put({ type: TEMPLATES_BULK_ACTIONS, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templatesBulkActionsLoad() {
	yield takeLatest(SG_TEMPLATES_BULK_ACTIONS, templatesBulkActions);
}

function* templatesAvailablePostmark(action) {
	try {
		const json = yield call(api.TEMPLATES_AVAILABLE_POSTMARK, action.payload);
		yield put({ type: TEMPLATES_AVAILABLE_POSTMARK, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templatesAvailablePostmarkLoad() {
	yield takeLatest(SG_TEMPLATES_AVAILABLE_POSTMARK, templatesAvailablePostmark);
}

function* templatesAutoAssign(action) {
	try {
		const json = yield call(api.TEMPLATES_AUTO_ASSIGN, action.payload);
		yield put({ type: TEMPLATES_AUTO_ASSIGN, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templatesAutoAssignLoad() {
	yield takeLatest(SG_TEMPLATES_AUTO_ASSIGN, templatesAutoAssign);
}

function* templateVerify(action) {
	try {
		const json = yield call(api.TEMPLATE_VERIFY, action.payload);
		yield put({ type: TEMPLATE_VERIFY, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* templateVerifyLoad() {
	yield takeLatest(SG_TEMPLATE_VERIFY, templateVerify);
}

export default function* index() {
	yield all([
		templatesLoad(),
		templateFetch(),
		templateAdd(),
		templateEdit(),
		templateDelete(),
		templatesStatisticsLoad(),
		templatesBulkActionsLoad(),
		templatesAvailablePostmarkLoad(),
		templatesAutoAssignLoad(),
		templateVerifyLoad(),
	]);
}

